// extracted by mini-css-extract-plugin
module.exports = {"auto-reload":"auto-reload_auto-reload__lqkVr","button":"auto-reload_button__Gs1fG"};